import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import * as fromGraphQl from './graphql';
import { NXDataSourcePrime } from '../../../services/dataSource/NXDataSourcePrime';
import { TaskType } from '../../../task/entities/taskType';
import { TaskTypesComponent } from './task-types.component';

export class TaskTypesDataSource extends NXDataSourcePrime<Event> {
  constructor(apollo: Apollo,
    @Inject('env') environment: any,
    private taskTypesComponent: TaskTypesComponent
    ) {
    super(apollo, fromGraphQl.TASKTYPES_QUERY, environment);
  }
  public selectedTaskType: TaskType;

  handleSubscriptionResult(data: fromGraphQl.TaskTypesQueryResponse): void {
    super.setSubject(
      data?.taskTypes ? TaskType.createTaskTypes(data?.taskTypes) : [],
      data?.taskTypes ? data?.taskTypes.length : 0
    );
    if (data?.taskTypes?.length > 0) {
      if(!this.selectedTaskType) {
        this.selectedTaskType = new TaskType(data?.taskTypes[0]);
        this.taskTypesComponent.setMenuItems();
      }
    }
    else {
      this.selectedTaskType = undefined;
    }
    this.querySubscription?.unsubscribe();
  }

  loadIssueTypes(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
